export default "__VITE_ASSET__njl6yXMN__"